<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <EtablissementSection />
  <AdresseExecutionContratSection />
  <DetailsComplementairesSection />
</template>

<script setup lang="ts">
  import AdresseExecutionContratSection from './sections/adresseExecutionContrat/AdresseExecutionContratSection.vue'
  import DetailsComplementairesSection from './sections/detailsComplementaires/DetailsComplementairesSection.vue'
  import EtablissementSection from './sections/etablissement/EtablissementSection.vue'
</script>
